/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyTravelInfo,
    JsonEventPartyTravelInfoFromJSON,
    JsonEventPartyTravelInfoFromJSONTyped,
    JsonEventPartyTravelInfoToJSON,
} from './JsonEventPartyTravelInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventPartyTravelInfo
 */
export interface ApiResultOfListOfJsonEventPartyTravelInfo {
    /**
     * 
     * @type {Array<JsonEventPartyTravelInfo>}
     * @memberof ApiResultOfListOfJsonEventPartyTravelInfo
     */
    data?: Array<JsonEventPartyTravelInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyTravelInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventPartyTravelInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyTravelInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyTravelInfo
     */
    result?: ApiResultOfListOfJsonEventPartyTravelInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyTravelInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyTravelInfoFromJSON(json: any): ApiResultOfListOfJsonEventPartyTravelInfo {
    return ApiResultOfListOfJsonEventPartyTravelInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyTravelInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventPartyTravelInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyTravelInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyTravelInfoToJSON(value?: ApiResultOfListOfJsonEventPartyTravelInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyTravelInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

